import type { FieldProps } from "@/types/form-types"
import { Checkbox } from "../ui/checkbox"
import { FormControl, FormField, FormItem, FormMessage } from "../ui/form"
import { Description } from "./components/description"
import { useFormStore } from "@/stores/use-form-store"
import { useLogicStore } from "@/stores/use-conditional-logic-store"
import { ErrorMessage } from "./components/error-message"

export const Acknowledgement = ({
	field,
	form,
	commonAttributes,
}: FieldProps) => {
	const { description } = commonAttributes
	const { shouldDisable } = useFormStore()
	const { hiddenFields, errors } = useLogicStore()

	if (hiddenFields[field.field_id]) return null

	const watched = form.watch(field.field_id)

	return (
		<FormField
			control={form.control}
			name={field.field_id}
			render={({ field: formField }) => {
				const value = formField.value ?? watched ?? "FALSE"
				return (
					<FormItem>
						<FormControl>
							<div className="flex gap-1">
								<Checkbox
									disabled={shouldDisable}
									checked={value === "TRUE"}
									onCheckedChange={checked => {
										formField.onChange(
											checked ? "TRUE" : "FALSE",
										)
									}}
									className="rounded-xs"
								/>
								{description && (
									<Description description={description} />
								)}
							</div>
						</FormControl>
						<FormMessage />
						<ErrorMessage error={errors[field.field_id]} />
					</FormItem>
				)
			}}
		/>
	)
}
